module.exports = __webpack_public_path__ + "img/img-hotline.95e7e4d3.png";